<form  loading-status [stopLoadingWhen]="contactForm.value" [formGroup]="contactForm" novalidate>
    <div class="modal-header">
        <h2>עריכת פרטי איש [{{ (id > 0 ? id : 'חדש') }}] </h2>
    </div> 
    <div class="modal-body"  *ngIf="contactForm.value">
        <contact-edit-personal [contactID]="id" [fg]="contactForm"></contact-edit-personal>
    </div>   
    <footer-edit-buttons [onSaveGoToBack]="false"  [navigateAfterSaving]="'contacts'" [dataProvider]="contactsData" [router]="router" [id]="id" [disabledDeleteButton]="id <= 0" [modelFormGroup]="contactForm"></footer-edit-buttons>
</form>  